module.exports = __webpack_public_path__ + "img/logo.00a6ba14.png";